import { render, staticRenderFns } from "./kvkk-edit.vue?vue&type=template&id=8363894e&scoped=true&"
import script from "./kvkk-edit.vue?vue&type=script&lang=js&"
export * from "./kvkk-edit.vue?vue&type=script&lang=js&"
import style0 from "./kvkk-edit.vue?vue&type=style&index=0&id=8363894e&prod&lang=scss&"
import style1 from "./kvkk-edit.vue?vue&type=style&index=1&id=8363894e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8363894e",
  null
  
)

export default component.exports